import React from 'react';
import { connect } from 'react-redux';
import { CreateCustomDialogFn, ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { selectSessionUser } from '~src/app/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/app/selectors/SiteUrlsSelectors';
import { AppState } from '~src/app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { Messages } from '~src/codegen/Localize';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { DialogType, DialogWidget } from '@tableau/widgets';

import { requestUploadBundlesAction } from '../actions/UploadBundlesActions';
import {
    UploadBundlesDialog, UploadBundlesDialogValues, UploadBundlesDispatchProps,
    UploadBundlesPropsFromReduxState
} from './UploadBundlesDialog';

export const mapDispatchToProps: MapDispatchToProps<UploadBundlesDispatchProps> = (dispatch) => ({
  uploadBundlesActionDispatch: (values: UploadBundlesDialogValues, oauthId: number, myContentUrl: string) => {
    dispatch(requestUploadBundlesAction({
        data: values,
        oauthId,
        myContentUrl
      })
    );
  }
});

const mapStateToProps: MapStateToProps<UploadBundlesPropsFromReduxState> = (state: AppState) => ({
  siteUrls: siteUrlsSelector(state),
  user: selectSessionUser(state),
});


const ConnectedUploadBundlesDialog = connect(mapStateToProps, mapDispatchToProps)(UploadBundlesDialog);

/**
 * Options used for ReactModalService
 */
export function UploadBundlesDialogOpts(
  oauthId: number
): CreateCustomDialogFn {
  return (closeAndDismiss) => {
    const dialogProps = ReactModalService.getDefaultDialogProps({
      type: DialogType.NormalWithTitleBar,
      title: Messages.connectToSalesforce_Title(),
      showCloseButton: false,
      dialogWidth: TabDialogWidth.width375px,
      shouldNotCloseOnGlassClick: true,
      testId: 'upload-bundles'
    }, closeAndDismiss);

    return (
      <DialogWidget {...dialogProps}>
        <ConnectedUploadBundlesDialog
          close={closeAndDismiss.close}
          oauthId={oauthId}
        />
      </DialogWidget>
    );
  };
}

